// extracted by mini-css-extract-plugin
module.exports = {"container":"Checkbox_container__2ZtrW","checkboxInput":"Checkbox_checkboxInput__6xNQf","checkmark":"Checkbox_checkmark__L89E7"};